import router from "@/router/index";
import * as model from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizing";
import {
  newEntityStoreHelper
} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  return filter;
}

export default newEntityStoreHelper(() => new model.SelfTestPelletizing(), newFilter)
  .withStates({
    idReport: 2,
    baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd",
  }) //TODO load at the application start
  .withActions({
    PelletizingGri(context, entity) {
      router.push({
        path: '/prd/selfTestPelletizingGri',
        query: {
          id: entity.id,
        }
      });
      context.dispatch("selfTestPelletizingGri/updateSelfTestId", entity.id, { root: true });
  

    },
    PelletizingPel(context, entity) {
      router.push({
        path: '/prd/selfTestPelletizingPel',
        query: {
          id: entity.id,
        }
      });
      context.dispatch("selfTestPelletizingPel/updateSelfTestId", entity.id, {
        root: true
      });
     
    },
    PelletizingCal(context, entity) {
      router.push({
        path: '/prd/selfTestPelletizingCal',
        query: {
          id: entity.id,
        }
      });
      context.dispatch("selfTestPelletizingCal/updateSelfTestId", entity.id, {
        root: true
      });
      
    },
    ReadSelfTestPelletizing(context) {
      context.dispatch("api/get", {
        url: context.state.baseModuleUrl + "/selfTestPelletizing" + "/readSelfTestPelletizing"
      }, {
        root: true
      })
        .then(response => {

          {

            context.commit('selfTestPelletizing' + "/setRows", response, {
              root: true
            });
          }
        });

    },
    
  })
  .buildStore()